import { generateIconsFromConfiguration } from '../../../helpers/dataTableActionIconHelper'
import { ActionIcons } from '../../../model'
import { filterApplicableActionsConfiguration } from '../../../pages/comunicationCenter/tabs/procedures/comunicationProdecures.service'

import { ProcedureModel } from '../../../pages/comunicationCenter/tabs/procedures/comunicationProcedures.model'
import { ServiceResponse } from '../../../model/serviceResponse'
import { ApiProcedures } from '../../../api/Argentia/endpoints/procedures/procedures.api'
import { createErrorServiceResponse, createSuccessServiceResponse } from '../../../helpers/serviceResponseHelper'

export const completeDataTableActions = (item: ProcedureModel): ProcedureModel => {
  return {
    ...item,
    actions:
      item.actionsConfiguration &&
      item.actionsConfiguration.length > 0 &&
      generateIconsFromConfiguration(
        item,
        filterApplicableActionsConfiguration(item, item.actionsConfiguration),
        new Map<ActionIcons, Function>([])
      )
  }
}

const apiProcedures = new ApiProcedures()

export const fetchProcedureItem = (
  idProcedure: number | undefined
): Promise<ServiceResponse<any>> => {
  return apiProcedures
    .Fetch(idProcedure)
    .then(res => {
      return createSuccessServiceResponse(res)
    })
    .catch(error => {
      return createErrorServiceResponse(error)
    })
}
